import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import Footer from './Footer';
import PreOrderModal from './components/PreOrderModal';

// this is the page for the Mary ...
function MaryStory() {
  // Pre-order modal state
  const [isPreOrderModalOpen, setIsPreOrderModalOpen] = useState(false);
  const basePrice = 899.99; // Full price

  // Pre-order modal functions
  const openPreOrderModal = () => {
    setIsPreOrderModalOpen(true);
  };

  const closePreOrderModal = () => {
    setIsPreOrderModalOpen(false);
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 via-indigo-50 to-purple-50">
      {/* Navigation */}
      <nav className="fixed top-2 md:top-4 left-0 right-0 z-50">
        <div className="max-w-7xl mx-auto px-4 md:px-6 flex justify-between items-center">
          <Link to="/" className="text-sm md:text-lg font-bold text-gray-900 bg-white/40 backdrop-blur-lg px-3 md:px-4 py-1.5 md:py-2 rounded-full shadow-lg border border-white/20">
            Goldilocks
          </Link>
          
          <div className="bg-white/40 backdrop-blur-lg rounded-full shadow-lg border border-white/20 px-1 py-1">
            <Link to="/" className="px-4 py-2 text-gray-700 hover:text-[#213B5C] hover:bg-white/30 rounded-full transition-all text-sm font-medium">
              ← Back to Home
            </Link>
          </div>
        </div>
      </nav>

      {/* Hero Section */}
      <section className="pt-24 pb-16 md:pt-32 md:pb-20">
        <div className="max-w-6xl mx-auto px-4 md:px-8">
          <div className="text-center mb-12 md:mb-16">
            <div className="inline-block bg-[#213B5C]/5 border border-[#213B5C]/20 rounded-full px-4 py-2 mb-6">
              <span className="text-[#213B5C] font-semibold text-sm">November 16, 1933 - Forever In Our Hearts</span>
            </div>
            
            <h1 className="text-4xl md:text-6xl lg:text-7xl font-black leading-tight text-gray-900 tracking-tight mb-6">
              <span className="block">Mary Louise</span>
              <span className="block text-[#213B5C] drop-shadow-[2px_2px_4px_rgba(33,59,92,0.3)]">Jones</span>
            </h1>
            
            <p className="text-xl md:text-2xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
              The heart and soul behind Goldilocks Smart Solutions — a woman whose love, warmth, and spirit continue to inspire everything we do.
            </p>
          </div>

          {/* Main Image */}
          <div className="flex justify-center mb-16">
            <div className="relative">
              <img 
                src="/assets/Thomas-gradma-mary.png" 
                alt="Mary Louise Jones" 
                className="w-80 h-96 md:w-96 md:h-[480px] object-cover object-top rounded-2xl shadow-2xl"
              />
              <div className="absolute -bottom-6 -right-6 bg-white rounded-xl p-4 shadow-lg">
                <div className="text-center">
                  <div className="text-2xl md:text-3xl font-black text-[#213B5C]">90</div>
                  <div className="text-sm text-gray-600">Years of Love</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Story Section */}
      <section className="py-16 md:py-20 bg-white">
        <div className="max-w-4xl mx-auto px-4 md:px-8">
          <div className="prose prose-lg md:prose-xl max-w-none">
            <h2 className="text-3xl md:text-4xl font-black text-gray-900 mb-8 text-center">
              A Life Of <span className="text-[#213B5C]">Love & Service</span>
            </h2>
            
            <div className="space-y-8 text-gray-700 leading-relaxed">
              <p className="text-lg md:text-xl first-letter:text-6xl first-letter:font-black first-letter:text-[#213B5C] first-letter:float-left first-letter:mr-3 first-letter:mt-1">
                Mary Louise Jones was born on November 16, 1933, in Florence, Mississippi, to Nanny Lee and L.C. Hawthorne. 
                In 1949, she married the love of her life, John Albert Jones Jr., a devoted pastor, and together they raised 
                eight children—five boys and three girls.
              </p>
              
              <div className="bg-[#213B5C]/5 rounded-2xl p-8 my-12">
                <h3 className="text-2xl font-bold text-[#213B5C] mb-4">Known For Her Open Heart & Open Kitchen</h3>
                <p className="text-lg">
                  Mary made everyone feel at home. Her legendary biscuits, salmon croquettes, greens, mac and cheese, 
                  and banana pudding were just as comforting as her presence. She found joy in her garden, tending to 
                  flowers and vegetables with care, but her true calling was nurturing people—whether nursing the sick 
                  or feeding anyone who came to her door.
                </p>
              </div>
              
              <p className="text-lg md:text-xl">
                Mary's legacy of love, service, and warmth lives on through her children, grandchildren, and 
                great-grandchildren. <strong className="text-[#213B5C]">She is the inspiration behind everything we do.</strong>
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Legacy Section */}
      <section className="py-16 md:py-20 bg-gray-50">
        <div className="max-w-6xl mx-auto px-4 md:px-8">
          <div className="text-center mb-12">
            <h2 className="text-3xl md:text-4xl font-black text-gray-900 mb-4">
              Her <span className="text-[#213B5C]">Legacy Lives On</span>
            </h2>
            <p className="text-lg text-gray-600 max-w-3xl mx-auto">
              Every Goldilocks Smart Shower system installed is a tribute to Mary and all the grandparents 
              who deserve to age gracefully, safely, and independently at home.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="text-center bg-white rounded-xl p-8 shadow-lg">
              <div className="w-16 h-16 mx-auto mb-4 bg-[#213B5C]/10 rounded-full flex items-center justify-center">
                <svg className="w-8 h-8 text-[#213B5C]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z" />
                </svg>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-2">Love</h3>
              <p className="text-gray-600">Open heart, open kitchen — Mary's love welcomed everyone</p>
            </div>

            <div className="text-center bg-white rounded-xl p-8 shadow-lg">
              <div className="w-16 h-16 mx-auto mb-4 bg-[#213B5C]/10 rounded-full flex items-center justify-center">
                <svg className="w-8 h-8 text-[#213B5C]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
                </svg>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-2">Service</h3>
              <p className="text-gray-600">Nursing the sick, feeding the hungry — service was her calling</p>
            </div>

            <div className="text-center bg-white rounded-xl p-8 shadow-lg">
              <div className="w-16 h-16 mx-auto mb-4 bg-[#213B5C]/10 rounded-full flex items-center justify-center">
                <svg className="w-8 h-8 text-[#213B5C]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z" />
                </svg>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-2">Inspiration</h3>
              <p className="text-gray-600">Her spirit guides our mission to keep families safe</p>
            </div>
          </div>
        </div>
      </section>

      {/* Call to Action */}
      <section className="py-16 md:py-20 bg-[#213B5C] text-white">
        <div className="max-w-4xl mx-auto px-4 md:px-8 text-center">
          <h2 className="text-3xl md:text-4xl font-black mb-6">
            Honor Mary's Memory
          </h2>
          <p className="text-lg md:text-xl mb-8 opacity-90">
            Join us in continuing Mary's legacy of love and care by making homes safer for seniors everywhere.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link 
              to="/" 
              className="bg-white text-[#213B5C] px-8 py-3 rounded-full font-semibold hover:bg-gray-100 transition-all shadow-lg"
            >
              Learn About Our Mission
            </Link>
            <button 
              onClick={openPreOrderModal}
              className="bg-gradient-to-r from-green-500 to-green-600 text-white px-8 py-3 rounded-full font-semibold hover:from-green-600 hover:to-green-700 transition-all shadow-lg"
            >
              Order Now
            </button>
          </div>
        </div>
      </section>

      <Footer />

      {/* Pre-order Modal */}
      <PreOrderModal 
        isOpen={isPreOrderModalOpen}
        onClose={closePreOrderModal}
        basePrice={basePrice}
      />
    </div>
  );
}

export default MaryStory;
